import { useReducer } from "react";
import { toast } from "react-toastify";
import { firestore, auth, timestamp } from "../../firebase/utiles";
import AuthContext from "./AuthContext";
import AuthReducer from "./AuthReducer";
import {
  INICIAR_SESION,
  AUTENTICADO,
  CERRAR_SESION,
  AUTENTICADO_ERROR,
} from "../types";

const AuthState = ({ children }) => {
  const initialState = {
    usuario: null,
  };

  const [state, dispatch] = useReducer(AuthReducer, initialState);

  // verificar si el usuario ya esta autenticado
  const usuarioAutenticado = () => {
    auth.onAuthStateChanged(function (user) {
      if (user) {
        const docRef = firestore.collection("usuarios").doc(user.uid);
        docRef
          .get()
          .then((doc) => {
            if (doc.exists) {
              dispatch({
                type: AUTENTICADO,
                payload: doc.data(),
              });
            } else {
              toast.error("Error al buscar el usuario");
            }
          })
          .catch((error) => {
            toast.error("Error al buscar el usuario");
          });
      }
    });
  };

  // registrar nuevo usuario
  const registrarUsuario = (data) => {
    auth
      .createUserWithEmailAndPassword(data.correo, data.clave)
      .then((userCredentials) => {
        const user = userCredentials.user;
        user.updateProfile({
          displayName: data.nombre,
        });

        const creado = timestamp();
        const id = auth.currentUser.uid;
        const nombre = data.nombre;
        const celular = data.celular;
        const correo = data.correo;
        const administrador = false;

        firestore.collection("usuarios").doc(id).set({
          id,
          correo,
          nombre,
          celular,
          administrador,
          creado,
        });

        const docRef = firestore.collection("usuarios").doc(id);
        docRef.get().then((doc) => {
          if (doc.exists) {
            dispatch({
              type: INICIAR_SESION,
              payload: doc.data(),
            });
          }
        });
        usuarioAutenticado();
      })
      .catch((error) => {
        dispatch({ type: AUTENTICADO_ERROR });
        const errorCode = error.code;
        if (errorCode === "auth/email-already-in-use") {
          toast.error("Ya existe un usuario con esta cuenta de correo");
        }
      });
  };

  // iniciar sesion
  const iniciarSesion = (data) => {
    auth
      .signInWithEmailAndPassword(data.correo, data.clave)
      .then((userCredentials) => {
        const user = userCredentials;
        const docRef = firestore.collection("usuarios").doc(user.uid);
        docRef.get().then((doc) => {
          if (doc.exists) {
            dispatch({
              type: INICIAR_SESION,
              payload: doc.data(),
            });
          }
        });
        usuarioAutenticado();
      })
      .catch((error) => {
        const errorCode = error.code;
        if (errorCode === "auth/user-not-found") {
          toast.error("Credenciales no validas, por favor intentelo de nuevo.");
        } else if (errorCode === "auth/wrong-password") {
          toast.error("Credenciales no validas, por favor intentelo de nuevo.");
        } else {
          toast.error("Ocurrio un error.");
        }
      });
  };

  // cerrar sesion
  const cerrarSesion = async () => {
    await auth.signOut();
    dispatch({ type: CERRAR_SESION });
  };

  return (
    <AuthContext.Provider
      value={{
        usuario: state.usuario,
        usuarioAutenticado,
        registrarUsuario,
        iniciarSesion,
        cerrarSesion,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthState;
